import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  StyledTabs,
  StyledTab,
  StyledBadge,
} from './styles';

const Tabs = ({
  className,
  tabsConfig,
  selectedTab,
  onSelectTab,
  variant,
  ...props
}) => {
  const parsedTabs = useMemo(() => {
    const a11yProps = (index) => ({
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    });

    return Object.keys(tabsConfig)
      .map((tab, index) => {
        const {
          label = '',
          icon: TabIcon,
          hidden = false,
          count = 0,
        } = tabsConfig[tab];
        return (
          <StyledTab
            label={label && (
              <StyledBadge badgeContent={count}>
                {label}
              </StyledBadge>
            )}
            key={tab}
            icon={TabIcon && (
              <TabIcon />
            )}
            value={tab}
            $hidden={hidden}
            {...a11yProps(index)}
          />
        );
      });
  }, [tabsConfig]);

  return (
    <StyledTabs
      value={selectedTab}
      onChange={(_, value) => onSelectTab(value)}
      className={className}
      variant={variant}
      scrollButtons
      {...props}
    >
      {parsedTabs}
    </StyledTabs>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  tabsConfig: PropTypes.object.isRequired,
  selectedTab: PropTypes.string,
  onSelectTab: PropTypes.func,
  props: PropTypes.object,
  variant: PropTypes.string,
};

Tabs.defaultProps = {
  className: '',
  selectedTab: 0,
  onSelectTab: () => {},
  props: {},
  variant: 'scrollable',
};

export default Tabs;
